import React, { useState, useEffect, useMemo, useCallback } from 'react';  
import { useLocation } from 'react-router-dom';  
import useCustomNavigate from '../../common_nextgen/common_components/Navigation/NextGenNavigation';  
import Form from '../../common_nextgen/common_components/form/Form';  
import { PRICE_SCHEDULE_MODES, ROUTE_PATHS } from '../../common_nextgen/utils/Constants';  
import { isAddMode, isEditMode, isReadOnlyMode } from '../../common_nextgen/utils/UtilFunctions';  
import { useAxios } from '../../common_nextgen/axios/AxiosHelper';  
import { useToast } from '../../common_nextgen/hooks/ToastContext';  
import FunctionKeys from '../../common_nextgen/common_components/FunctionKeys/FunctionKeys';  
import { screenInfo, formFields } from './StandardTrOOPScheduleStepDetailConfig';
import './css/StandardTrOOPScheduleStepDetailForm.css';
const StandardTrOOPScheduleStepDetailForm = ({ mode }) => {  
    const {axios_helper_no_header} = useAxios();
    const location = useLocation();  

    const stateVal = location.state;
    const [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    console.log("current state in form", currentState, previousState);

    const {
        selectedSchedules = [],
        selectedCodesListItem = "",
        selectedSteps = [],
        previousScreen = ROUTE_PATHS.MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS,
        currentIndex: initialIndex = 0,
        selectMode = false,
        paramsData: initialParamsData = {
            sbsScheduleName: selectedSchedules[initialIndex].sbsScheduleName,
            sbdStepNumber: selectedSteps[initialIndex].sbdStepNumber,
        },
    } = currentState;

    const navigateToPage = useCustomNavigate();  
    const [selectedOption, setSelectedOption] = useState('no');  
    const [currentIndex, setCurrentIndex] = useState(initialIndex);  
    const [currentMode, setCurrentMode] = useState(mode);  
    const [initialFormData, setInitialFormData] = useState({});  
    const [dataForSubmission, setDataForSubmission] = useState({});  
    const [constraintErrors, setConstraintErrors] = useState([]);  
    const [paramsData, setParamsData] = useState(initialParamsData);
    const toast = useToast();  
    
    const handleBack = useCallback(() => {
        if (currentIndex < selectedSteps.length - 1) {
            setCurrentIndex(currentIndex + 1);
            setCurrentMode(mode);
        } else {
            navigateToPage(previousScreen, previousState);
        }
    }, [currentIndex, selectedSteps]);
    
    const getPageTitle = () => {  
      const [screenTitle, screenNumber] = screenInfo.VIEW;  
      return (  
        <>  
          <span className="title">{screenTitle}</span>  
          <span>{'-'}</span>  
          <span className="screen-number">{screenNumber}</span>  
        </>  
      );  
    };  
    
    const submitFormData = (data) => {  
      setDataForSubmission(data);  
    };  
    
    const submitForm = async (dataForSubmission) => {  
      let url = '';  
      let verb = '';  
      let screenNumber = '';  
    

    
      if (isAddMode(currentMode)) {  
        url = 'api/priceschedule/create';  
        verb = 'POST';  
        screenNumber = screenInfo.VIEW[1];  
      } else {  
        url = 'api/priceschedule/update';  
        verb = 'PUT';  
        screenNumber = screenInfo.VIEW[1];  
    
        if (JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)) {  
          toast.current.show({ severity: 'info', summary: '', detail: 'No Change of Information', life: 3000 });  
          return;  
        }  
      }  
    
      const data = { ...dataForSubmission, screenNumber };  
    
      try {  
        const { responseStatus } = await axios_helper_no_header(verb, url, data, null);  
        toast.current.show({ severity: 'success', summary: '', detail: responseStatus.message, life: 3000 });  
      } catch (error) {  
        const { responseStatus: { displayErrorFields = null, message } = {} } = error.data;  
        if (displayErrorFields === null) {  
          toast.current.show({ severity: 'error', summary: '', detail: message, life: 3000 });  
        } else {  
          setConstraintErrors(displayErrorFields);  
        }  
      } 
    };  
    
    const [keyFunc, keyName] = useMemo(() => {  
      const keyFunc = {};  
      const keyName = {};  
    
      keyFunc.F12 = handleBack;  
      keyName.F12 = 'Back';  
    
      if (isAddMode(currentMode)) {  
        keyFunc.F10 = submitFormData;  
        keyName.F10 = 'Save';  
      } else if (isEditMode(currentMode)) {  
        keyFunc.F10 = submitFormData;  
        keyName.F10 = 'Save';  
        keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);  
        keyName.chmod = 'View';  
      } else if (isReadOnlyMode(currentMode)) {  
        keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);  
      }  
    
      return [keyFunc, keyName];  
    }, [currentMode, currentIndex]);  
    
    useEffect(() => {  
      const fetchInitialData = async () => {  
        const url = `api/sbdStdBrandDiscDetail/stepDetail`;  
        const params = {
          sbsScheduleName: selectedSteps[currentIndex].sbsScheduleName,
          sbdStepNumber: selectedSteps[currentIndex].sbdStepNumber,
          hideSchInfo: true,
        }
        const { responseData } = await axios_helper_no_header('GET', url,{}, params);  
        setInitialFormData(responseData);  
      };  
    
      fetchInitialData();  
    }, [mode, currentIndex]);  
    
    return (  
      <div className="grid container">  
        <div className="col col-12">  
          <FunctionKeys keyFunc={keyFunc} keyName={keyName} />  
        </div>  
        <div className="col col-12">  
          <h1>{getPageTitle()}</h1>  
        </div>  
        <div className="col col-12">  
          <Form  
            formData={initialFormData}  
            formFields={formFields}  
            mode={currentMode}  
            submitFormData={submitForm}  
            constraintErrors={constraintErrors}  
          />  
        </div>  
      </div>  
    );  
  };  
    
  export default StandardTrOOPScheduleStepDetailForm;